module.exports = __webpack_public_path__ + "static/media/numerals_3_and4_img.64876fec.JPG";